import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '../../common/Button'
import { StepHeader } from '../StepHeader'

interface LanguagePreferenceStepProps {
  initialValue?: 'en' | 'zh-Hant'
  onNext: (value: 'en' | 'zh-Hant') => void
  onBack: () => void
}

/**
 * Language preference selection for loved one (FR-015)
 */
export function LanguagePreferenceStep({
  initialValue = 'en',
  onNext,
  onBack,
}: LanguagePreferenceStepProps) {
  const { t } = useTranslation()
  const [language, setLanguage] = useState<'en' | 'zh-Hant'>(initialValue)

  const containerStyles = {
    fontFamily: 'system-ui, -apple-system, sans-serif',
  }

  const labelStyles = {
    display: 'block',
    marginBottom: '8px',
    fontSize: '14px',
    fontWeight: 600,
    color: '#333',
  }

  const selectStyles = {
    display: 'block',
    width: '100%',
    minHeight: '44px',
    fontSize: '16px',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    padding: '12px 16px',
    border: '2px solid #ddd',
    borderRadius: '8px',
    outline: 'none',
    transition: 'border-color 0.2s ease',
    backgroundColor: '#fff',
    cursor: 'pointer',
    marginBottom: '2rem',
  }

  return (
    <div style={containerStyles}>
      <StepHeader type="loved-one" title="What language do they prefer?" />

      <label style={labelStyles} htmlFor="language-select">
        {t('onboarding.lovedOne.languageLabel')}
      </label>

      <select
        id="language-select"
        style={selectStyles}
        value={language}
        onChange={e => setLanguage(e.target.value as 'en' | 'zh-Hant')}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault()
            onNext(language)
          }
        }}
        onFocus={e => {
          e.currentTarget.style.borderColor = '#2563eb'
        }}
        onBlur={e => {
          e.currentTarget.style.borderColor = '#ddd'
        }}
        autoFocus
      >
        <option value="en">{t('onboarding.lovedOne.languageEnglish')}</option>
        <option value="zh-Hant">{t('onboarding.lovedOne.languageCantonese')}</option>
      </select>

      <div style={{ display: 'flex', gap: '1rem' }}>
        <Button variant="outline" onClick={onBack} style={{ flex: 1 }}>
          {t('onboarding.navigation.back')}
        </Button>
        <Button onClick={() => onNext(language)} style={{ flex: 1 }}>
          {t('onboarding.navigation.next')}
        </Button>
      </div>
    </div>
  )
}
